import React from 'react';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement,
  LineElement, Tooltip, Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Filler);

/** Mini gráfico de línea sin ejes, usado dentro de las KPI cards. */
export function Sparkline({ data, color = '#3b82f6' }) {
  const chartData = {
    labels: data.map((_, i) => i),
    datasets: [{
      data,
      borderColor: color,
      backgroundColor: `${color}22`,
      borderWidth: 2,
      pointRadius: 0,
      fill: true,
      tension: 0.35,
    }],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    plugins: { tooltip: { enabled: false }, legend: { display: false } },
    scales: { x: { display: false }, y: { display: false } },
    elements: { point: { radius: 0 } },
  };
  return (
    <div style={{ height: 36, width: '100%' }}>
      <Line data={chartData} options={options} />
    </div>
  );
}

/** Gráfico de línea con 2 series comparativas (ej. mes actual vs mes pasado). */
export function TrendLineChart({ labels, series, height = 260 }) {
  const chartData = {
    labels,
    datasets: series.map(s => ({
      label: s.label,
      data: s.data,
      borderColor: s.color,
      backgroundColor: `${s.color}1a`,
      borderWidth: 2,
      borderDash: s.dashed ? [6, 4] : undefined,
      pointRadius: 0,
      pointHoverRadius: 4,
      fill: s.fill !== false,
      tension: 0.3,
    })),
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    interaction: { mode: 'index', intersect: false },
    plugins: {
      legend: { position: 'bottom', labels: { boxWidth: 10, font: { size: 11 }, color: '#64748b' } },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.dataset.label}: S/ ${parseFloat(ctx.raw || 0).toLocaleString('es-PE', { minimumFractionDigits: 2 })}`,
        },
      },
    },
    scales: {
      x: { grid: { display: false }, ticks: { color: '#94a3b8', font: { size: 10.5 } } },
      y: {
        grid: { color: '#f1f5f9' },
        ticks: {
          color: '#94a3b8', font: { size: 10.5 },
          callback: (v) => v >= 1000 ? `${v / 1000}k` : v,
        },
      },
    },
  };
  return (
    <div style={{ height, width: '100%' }}>
      <Line data={chartData} options={options} />
    </div>
  );
}
